export const CONFIG = {
  baseurl: 'https://dswm8lgohd.execute-api.eu-west-1.amazonaws.com/qa',
  cidaas:
    'https://accounts.rehau.com/authz-srv/authz?client_id=6b319fc7-5309-482d-8c62-47e0b86c3ae1&response_type=token&nonce=12345&response_mode=query&scope=openid%20profile%20email%20roles&redirect_uri=',
  cidaas_revoke:
    'https://accounts.rehau.com/session/end_session?access_token_hint=',
  env: 'qa',
  appUrl: 'https://qa.crewcus.com'
};
